import { uploadMultiBase64ToS3 } from "../../../utils/s3Uploading";
import { addToast, TOAST_TYPES } from "../../toasts";

export const createUploadHandler = async ({
  formInstance,
  responseData,
  dispatch,
}) => {
  try {
    let urls = [];
    let files = [];

    // main document
    const docPath = responseData?.doc?.put;
    const base64file = formInstance?.docData_;

    if (docPath && base64file) {
      urls.push(docPath);
      files.push(base64file);
    }

    // attachments
    const attachments = formInstance?.attachments || [];
    const responseAttachments = responseData?.attachments || [];

    if (attachments.length === responseAttachments.length) {
      responseAttachments.forEach((a, index) => {
        const attachment = attachments[index];
        const file = attachment?._tempData?.data;
        const url = a?.pdf?.put;

        if (file && url) {
          urls.push(url);
          files.push(file);
        }
      });
    }

    if (!urls.length) {
      return;
    }

    await uploadMultiBase64ToS3({
      signedUrls: urls,
      files: files,
    });
    return;
  } catch (e) {
    dispatch(
      addToast({
        type: TOAST_TYPES.ERROR,
        title: "Filuppladdning misslyckades",
      })
    );
    return;
  }
};
